module.exports = __webpack_public_path__ + "img/7.789cc264.png";